import { render, staticRenderFns } from "./revenue.vue?vue&type=template&id=0050f844&scoped=true"
import script from "./revenue.vue?vue&type=script&lang=js"
export * from "./revenue.vue?vue&type=script&lang=js"
import style0 from "./revenue.vue?vue&type=style&index=0&id=0050f844&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0050f844",
  null
  
)

export default component.exports